import React from 'react';
import { FilterGroupTitle, SkeletonContainer, FilterGroupContainer, FilterResultRowContainer } from './filter-group.styled';
import { SkeletonItem } from '../search-skeleton';
export var ColumnFilterGroup = function ColumnFilterGroup(_ref) {
  var children = _ref.children,
    title = _ref.title,
    isLoading = _ref.isLoading,
    avatarShape = _ref.avatarShape;
  return /*#__PURE__*/React.createElement(FilterGroupContainer, null, /*#__PURE__*/React.createElement(FilterGroupTitle, null, title), !isLoading ? children : /*#__PURE__*/React.createElement(SkeletonContainer, null, /*#__PURE__*/React.createElement(SkeletonItem, {
    avatarShape: avatarShape,
    isShimmering: true
  }), /*#__PURE__*/React.createElement(SkeletonItem, {
    avatarShape: avatarShape,
    isShimmering: true
  }), /*#__PURE__*/React.createElement(SkeletonItem, {
    avatarShape: avatarShape,
    isShimmering: true
  })));
};
export var RowFilterGroup = function RowFilterGroup(_ref2) {
  var children = _ref2.children,
    title = _ref2.title,
    isLoading = _ref2.isLoading,
    _ref2$avatarShape = _ref2.avatarShape,
    avatarShape = _ref2$avatarShape === void 0 ? 'none' : _ref2$avatarShape;
  return /*#__PURE__*/React.createElement(FilterGroupContainer, null, /*#__PURE__*/React.createElement(FilterGroupTitle, null, title), /*#__PURE__*/React.createElement(FilterResultRowContainer, null, !isLoading ? children : /*#__PURE__*/React.createElement(SkeletonContainer, null, /*#__PURE__*/React.createElement(SkeletonItem, {
    avatarShape: avatarShape,
    isShimmering: true
  }))));
};